import { Navigate, Outlet, useLocation } from 'react-router';

import useAuthContext from 'hooks/useAuthContext';

interface PropTypes {
  allowRoles: Array<AccessTokenPayload['userRole']>;
}

function RequireAuth({ allowRoles }: PropTypes) {
  const { accessToken, isInitializing, userRole } = useAuthContext();
  const location = useLocation();

  // while auth is initializing, do not render anything
  if (isInitializing) {
    return null;
  }

  // verify there is an access token
  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // verify the user has a role that is allowed to access this route
  if (userRole && allowRoles.includes(userRole)) {
    return <Outlet />;
  }

  // redirect user to login page without state to redirect to the default page for the users role
  return <Navigate to="/login" replace />;
}

export default RequireAuth;
